import { render, staticRenderFns } from "./TrashIcon.vue?vue&type=template&id=3674ad8a"
import script from "./TrashIcon.vue?vue&type=script&lang=js"
export * from "./TrashIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports